import { render, staticRenderFns } from "./cly-simple-table.vue?vue&type=template&id=33695033"
import script from "./cly-simple-table.vue?vue&type=script&lang=js"
export * from "./cly-simple-table.vue?vue&type=script&lang=js"
import style0 from "./cly-simple-table.vue?vue&type=style&index=0&id=33695033&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports